import React from "react";
import { useAtom } from "jotai";
import { appConstants } from "../../AtomStore/store";

const Item = ({ item, loading }) => {
  const [constants] = useAtom(appConstants);

  return (
    <div className="col-span-6 xl:col-span-4 lg:col-span-4">
      <div className="relative rounded-lg overflow-hidden h-[300px] sm:h-[350px] md:h-[330px] lg:h-[320px] xl:h-[400px]">
        <img
          className="w-full h-full object-cover object-top"
          src={constants?.teachersPath + item.User_Image}
          alt="teacher"
        />
        <div className="absolute bottom-0 left-0 right-0 bg-black/60 p-2">
          <h2 className="text-white text-center text-base xl:text-lg font-medium leading-tight break-words">
            {item.User_Name}
          </h2>
        </div>
      </div>
    </div>
  );
};

export default Item;
